import PropTypes from 'prop-types'
import { iconSizes } from '../icons-sizes'
import { SvgIconComponent } from '../styledComponents'

export function Datasets({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M23.9492 20.4C32.6477 20.4 39.6992 17.1765 39.6992 13.2C39.6992 9.22355 32.6477 6 23.9492 6C15.2507 6 8.19922 9.22355 8.19922 13.2C8.19922 17.1765 15.2507 20.4 23.9492 20.4Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.7012 20.3999C39.7012 24.3757 32.6497 27.5999 23.9512 27.5999C15.2527 27.5999 8.20117 24.3757 8.20117 20.3999"
        stroke="#FF6633"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.7012 27.6003C39.7012 31.5761 32.6497 34.8003 23.9512 34.8003C15.2527 34.8003 8.20117 31.5761 8.20117 27.6003"
        stroke="#FF6633"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.7012 13.1279V34.7999C39.7012 38.7757 32.6497 41.9999 23.9512 41.9999C15.2527 41.9999 8.20117 38.7757 8.20117 34.7999V13.1279"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Groups({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M40.4984 24.5061C40.5579 24.0789 40.5877 23.6481 40.588 23.2168C40.588 20.4668 39.4956 17.8293 37.551 15.8847C35.6064 13.9401 32.969 12.8477 30.2189 12.8477C27.4688 12.8477 24.8312 13.9401 22.8866 15.8847C20.942 17.8293 19.8496 20.4668 19.8496 23.2168C19.8506 23.6481 19.8804 24.0788 19.9391 24.5061C20.8271 33.2153 30.2189 44 30.2189 44C30.2189 44 39.6104 33.2153 40.4984 24.5061Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.8142 6.96558V8.44628H13.9258V6.96558"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.8142 6.96141V5.48071H21.3334V4H15.4086V5.48071H13.9277V6.96141"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.7376 9.97187V6.96558H22.8125"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9271 33.6307V27.7057H8.00201"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.7929 33.631H13.9251L8 27.706V6.96564H13.9251"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9258 23.262H16.8893"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M17.649 18.8175H13.9258"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M20.1542 14.3733H13.9258"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M40.4984 24.5061C40.5579 24.0789 40.5877 23.6481 40.588 23.2168C40.588 20.4668 39.4956 17.8293 37.551 15.8847C35.6064 13.9401 32.969 12.8477 30.2189 12.8477C27.4688 12.8477 24.8312 13.9401 22.8866 15.8847C20.942 17.8293 19.8496 20.4668 19.8496 23.2168C19.8506 23.6481 19.8804 24.0788 19.9391 24.5061C20.8271 33.2153 30.2189 44 30.2189 44C30.2189 44 39.6104 33.2153 40.4984 24.5061Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.2216 27.6629C32.676 27.6629 34.6658 25.6731 34.6658 23.2186C34.6658 20.7642 32.676 18.7744 30.2216 18.7744C27.7671 18.7744 25.7773 20.7642 25.7773 23.2186C25.7773 25.6731 27.7671 27.6629 30.2216 27.6629Z"
        stroke="#FF6633"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Licenses({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M14.2658 16.2425C16.5419 16.2425 18.387 14.3973 18.387 12.1212C18.387 9.84514 16.5419 8 14.2658 8C11.9897 8 10.1445 9.84514 10.1445 12.1212C10.1445 14.3973 11.9897 16.2425 14.2658 16.2425Z"
        stroke="#141A21"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5498 27.9864H6.01604C5.90196 25.9466 6.39844 23.9191 7.44184 22.1627C8.48524 20.4063 10.0283 19.0006 11.8742 18.1251C12.61 18.5111 13.4285 18.7128 14.2595 18.7128C15.0905 18.7128 15.909 18.5111 16.6449 18.1251C16.9085 18.2269 17.1663 18.3437 17.4166 18.4748"
        stroke="#141A21"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.758 16.2425C32.034 16.2425 33.8792 14.3973 33.8792 12.1212C33.8792 9.84514 32.034 8 29.758 8C27.4819 8 25.6367 9.84514 25.6367 12.1212C25.6367 14.3973 27.4819 16.2425 29.758 16.2425Z"
        stroke="#141A21"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.435 21.9464C35.5084 20.1991 33.9849 18.8429 32.142 18.125C31.4062 18.5111 30.5874 18.7127 29.7564 18.7127C28.9254 18.7127 28.1069 18.5111 27.371 18.125C27.1075 18.2269 26.8499 18.3436 26.5996 18.4747"
        stroke="#141A21"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.284 28.1545C24.814 28.1545 26.865 26.1036 26.865 23.5736C26.865 21.0436 24.814 18.9927 22.284 18.9927C19.7541 18.9927 17.7031 21.0436 17.7031 23.5736C17.7031 26.1036 19.7541 28.1545 22.284 28.1545Z"
        stroke="#141A21"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1224 39.9846C12.998 37.8228 13.5607 35.6769 14.73 33.8542C15.8993 32.0316 17.615 30.6256 19.632 29.8375L19.6661 29.8555C20.0439 30.048 20.4413 30.1995 20.8514 30.3072C20.8914 30.3192 20.9373 30.3251 20.9773 30.3351C21.1422 30.3734 21.309 30.4035 21.4769 30.4251C21.5329 30.4251 21.5849 30.4431 21.6428 30.4491C21.8558 30.4737 22.0698 30.487 22.2843 30.489C22.4947 30.487 22.705 30.4737 22.914 30.4491L23.0699 30.4311C23.2717 30.4045 23.4718 30.3665 23.6693 30.3171H23.6793C23.8792 30.2652 24.0692 30.2012 24.2571 30.1333L24.401 30.0813C24.5609 30.0114 24.7226 29.9434 24.8765 29.8634C24.8945 29.8515 24.9165 29.8454 24.9385 29.8354"
        stroke="#141A21"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.8749 33.0332L39.7463 32.0199C39.6965 31.9962 39.6573 31.9549 39.6363 31.9039L39.4564 31.4703C39.4366 31.4188 39.4366 31.3618 39.4564 31.3103L40.2459 29.0878C40.2602 29.0482 40.2628 29.0054 40.2536 28.9644C40.2444 28.9233 40.2237 28.8857 40.194 28.856L39.1366 27.7987C39.1069 27.769 39.0694 27.7483 39.0283 27.7391C38.9873 27.7299 38.9444 27.7325 38.9048 27.7467L36.6823 28.5362C36.6309 28.5561 36.5739 28.5561 36.5224 28.5362L36.0887 28.3563C36.0377 28.3353 35.9965 28.2962 35.9728 28.2464L34.9595 26.1178C34.9414 26.0802 34.9131 26.0483 34.8777 26.026C34.8424 26.0038 34.8014 25.992 34.7596 25.9919H33.2626C33.2208 25.992 33.1799 26.0038 33.1445 26.026C33.1091 26.0483 33.0808 26.0802 33.0628 26.1178L32.0494 28.2464C32.0258 28.2962 31.9845 28.3353 31.9335 28.3563L31.4998 28.5362C31.4484 28.5561 31.3913 28.5561 31.3399 28.5362L29.1174 27.7467C29.0778 27.7325 29.035 27.7299 28.9939 27.7391C28.9529 27.7483 28.9153 27.769 28.8855 27.7987L27.8283 28.856C27.7985 28.8857 27.7778 28.9233 27.7686 28.9644C27.7594 29.0054 27.7621 29.0482 27.7763 29.0878L28.5658 31.3103C28.5857 31.3618 28.5857 31.4188 28.5658 31.4703L28.3859 31.9039C28.3649 31.9549 28.3257 31.9962 28.276 32.0199L26.1474 33.0332C26.1097 33.0512 26.0779 33.0796 26.0556 33.115C26.0334 33.1503 26.0215 33.1913 26.0215 33.2331V34.73C26.0215 34.7718 26.0334 34.8128 26.0556 34.8481C26.0779 34.8835 26.1097 34.9118 26.1474 34.9299L28.276 35.9432C28.3258 35.9667 28.3651 36.0081 28.3859 36.0592L28.5658 36.4929C28.5857 36.5443 28.5857 36.6013 28.5658 36.6528L27.7763 38.8753C27.7621 38.9149 27.7594 38.9577 27.7686 38.9987C27.7778 39.0398 27.7985 39.0774 27.8283 39.1071L28.8855 40.1644C28.9153 40.1941 28.9529 40.2148 28.9939 40.224C29.035 40.2332 29.0778 40.2306 29.1174 40.2163L31.3399 39.4269C31.3913 39.407 31.4484 39.407 31.4998 39.4269L31.9335 39.6068C31.9845 39.6277 32.0258 39.6669 32.0494 39.7167L33.0628 41.8453C33.0808 41.8829 33.1091 41.9148 33.1445 41.937C33.1799 41.9593 33.2208 41.9712 33.2626 41.9712H34.7596C34.8014 41.9712 34.8424 41.9593 34.8777 41.937C34.9131 41.9148 34.9414 41.8829 34.9595 41.8453L35.9728 39.7167C35.9965 39.6669 36.0377 39.6277 36.0887 39.6068L36.5224 39.4269C36.5739 39.407 36.6309 39.407 36.6823 39.4269L38.9048 40.2163C38.9444 40.2306 38.9873 40.2332 39.0283 40.224C39.0694 40.2148 39.1069 40.1941 39.1366 40.1644L40.194 39.1071C40.2237 39.0774 40.2444 39.0398 40.2536 38.9987C40.2628 38.9577 40.2602 38.9149 40.2459 38.8753L39.4564 36.6528C39.4366 36.6013 39.4366 36.5443 39.4564 36.4929L39.6363 36.0592C39.6571 36.0081 39.6964 35.9667 39.7463 35.9432L41.8749 34.9299C41.9125 34.9118 41.9443 34.8835 41.9666 34.8481C41.9889 34.8128 42.0007 34.7718 42.0007 34.73V33.2331C42.0007 33.1913 41.9889 33.1503 41.9666 33.115C41.9443 33.0796 41.9125 33.0512 41.8749 33.0332ZM34.0061 36.6468C33.4792 36.6468 32.9641 36.4905 32.526 36.1977C32.0878 35.905 31.7463 35.489 31.5447 35.0021C31.343 34.5153 31.2903 33.9796 31.3931 33.4628C31.4959 32.946 31.7497 32.4713 32.1222 32.0987C32.4948 31.7261 32.9696 31.4724 33.4864 31.3696C34.0032 31.2668 34.5389 31.3195 35.0257 31.5211C35.5125 31.7228 35.9286 32.0643 36.2213 32.5024C36.514 32.9405 36.6703 33.4556 36.6703 33.9825C36.6703 34.6891 36.3896 35.3668 35.89 35.8664C35.3903 36.3661 34.7127 36.6468 34.0061 36.6468Z"
        stroke="#FF6633"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Maestro({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M44 25.5452C44.0003 25.596 43.9907 25.6464 43.9715 25.6934C43.9523 25.7404 43.9239 25.7831 43.8881 25.8191C43.8523 25.8552 43.8098 25.8837 43.7629 25.9032C43.716 25.9227 43.6657 25.9328 43.615 25.9328H40.8271C40.6726 25.933 40.5232 25.9885 40.4062 26.0894C40.2892 26.1904 40.2123 26.33 40.1895 26.4828C40.0071 27.6671 39.6943 28.8277 39.2569 29.9434C39.1994 30.0878 39.1958 30.2482 39.2467 30.3951C39.2977 30.542 39.3999 30.6656 39.5345 30.7435L41.9397 32.1336C41.9837 32.1585 42.0225 32.192 42.0536 32.2319C42.0847 32.2717 42.1075 32.3172 42.121 32.366C42.1345 32.4148 42.1382 32.4658 42.132 32.516C42.1258 32.5662 42.1097 32.6147 42.0848 32.6587L40.5371 35.3415C40.4863 35.4306 40.4021 35.4958 40.3032 35.523C40.2044 35.5502 40.0987 35.5371 40.0095 35.4865L37.5992 34.0963C37.4658 34.0194 37.3093 33.9927 37.158 34.0212C37.0067 34.0496 36.8705 34.1312 36.7741 34.2513C36.0244 35.1836 35.1751 36.0312 34.2413 36.7791C34.1212 36.8755 34.0396 37.0117 34.0112 37.163C33.9827 37.3144 34.0094 37.4708 34.0863 37.6042L35.4764 40.0121C35.5021 40.0561 35.5187 40.1046 35.5256 40.1551C35.5324 40.2055 35.5293 40.2569 35.5163 40.3061C35.5033 40.3554 35.4807 40.4015 35.4498 40.442C35.4189 40.4825 35.3804 40.5165 35.3364 40.5421L32.6561 42.0898C32.6126 42.1156 32.5644 42.1325 32.5143 42.1397C32.4643 42.1469 32.4133 42.1442 32.3643 42.1316C32.3153 42.1191 32.2693 42.0969 32.2289 42.0666C32.1884 42.0363 32.1543 41.9983 32.1285 41.9548L30.7408 39.5495C30.663 39.4149 30.5394 39.3128 30.3925 39.2618C30.2456 39.2109 30.0852 39.2144 29.9408 39.2719C28.8247 39.7081 27.6644 40.0209 26.4803 40.2047C26.3281 40.2274 26.1891 40.3039 26.0887 40.4204C25.9882 40.537 25.9329 40.6858 25.9328 40.8397V43.615C25.9328 43.7177 25.8919 43.8164 25.8192 43.889C25.7465 43.9617 25.648 44.0026 25.5452 44.0026H22.4498C22.3472 44.0019 22.249 43.9608 22.1765 43.8883C22.104 43.8157 22.0629 43.7175 22.0623 43.615V40.8247C22.0627 40.6707 22.0075 40.5217 21.9069 40.405C21.8063 40.2884 21.6671 40.2118 21.5147 40.1895C20.3307 40.0057 19.1703 39.693 18.0543 39.257C17.9108 39.201 17.752 39.1981 17.6066 39.249C17.4612 39.2999 17.3389 39.4013 17.2616 39.5346L15.8689 41.9398C15.8435 41.984 15.8097 42.0228 15.7693 42.0539C15.7289 42.0851 15.6828 42.1079 15.6335 42.1211C15.5843 42.1343 15.5329 42.1377 15.4824 42.131C15.4318 42.1244 15.3831 42.1079 15.3389 42.0823L12.6611 40.5346C12.6168 40.5092 12.5781 40.4753 12.547 40.4349C12.5159 40.3945 12.493 40.3484 12.4798 40.2991C12.4665 40.2499 12.4632 40.1986 12.4698 40.148C12.4765 40.0975 12.493 40.0487 12.5185 40.0046L13.9087 37.5968C13.9856 37.4634 14.0122 37.3069 13.9838 37.1556C13.9554 37.0042 13.8738 36.868 13.7537 36.7716C12.8193 36.0208 11.9692 35.1708 11.2184 34.2363C11.1219 34.1157 10.9852 34.0336 10.8334 34.0051C10.6815 33.9767 10.5244 34.0037 10.3908 34.0813L7.98297 35.4715C7.89369 35.5231 7.78776 35.5375 7.68798 35.5115C7.63926 35.4983 7.59359 35.4756 7.55368 35.4447C7.51378 35.4138 7.48037 35.3753 7.45541 35.3315L5.90522 32.6512C5.87945 32.6077 5.86249 32.5595 5.85532 32.5094C5.84815 32.4594 5.85095 32.4084 5.86348 32.3594C5.87602 32.3104 5.89809 32.2644 5.92842 32.2239C5.95875 32.1835 5.9967 32.1493 6.0402 32.1235L8.44804 30.731C8.58284 30.654 8.68522 30.5307 8.73624 30.3841C8.78725 30.2375 8.78344 30.0773 8.72555 29.9333C8.28957 28.8174 7.97771 27.657 7.79549 26.4729C7.77273 26.3201 7.6958 26.1804 7.57879 26.0795C7.46178 25.9785 7.31244 25.9229 7.1579 25.9228H4.38755C4.28476 25.9228 4.18614 25.8819 4.11346 25.8092C4.04078 25.7365 4 25.6381 4 25.5353V22.4473C4 22.3445 4.04078 22.246 4.11346 22.1734C4.18614 22.1007 4.28476 22.0598 4.38755 22.0598H7.16034C7.31451 22.0598 7.46358 22.0046 7.58054 21.9042C7.6975 21.8037 7.77463 21.6647 7.79793 21.5123C7.98028 20.3279 8.2931 19.1673 8.73059 18.0518C8.78809 17.9073 8.7917 17.7469 8.74074 17.6C8.68978 17.4531 8.58768 17.3295 8.45307 17.2516L6.04776 15.864C6.00375 15.839 5.9651 15.8057 5.93399 15.7659C5.90288 15.726 5.87993 15.6803 5.86646 15.6316C5.85299 15.5828 5.84925 15.5319 5.85547 15.4817C5.8617 15.4315 5.87773 15.383 5.9027 15.339L7.45045 12.6586C7.50188 12.5699 7.58638 12.5051 7.68546 12.4785C7.7348 12.465 7.78638 12.4616 7.83708 12.4685C7.88777 12.4753 7.9365 12.4925 7.98045 12.5187L10.3883 13.9088C10.5215 13.9854 10.6777 14.0121 10.8289 13.9842C10.98 13.9562 11.1163 13.8755 11.2134 13.7563C11.9637 12.8199 12.8148 11.9688 13.7512 11.2185C13.8719 11.122 13.9539 10.9853 13.9823 10.8334C14.0108 10.6816 13.9838 10.5245 13.9063 10.3909L12.5161 7.98304C12.4901 7.93895 12.473 7.89016 12.466 7.83944C12.4589 7.78873 12.462 7.73712 12.475 7.6876C12.4881 7.63808 12.5107 7.59156 12.5418 7.55086C12.5729 7.51017 12.6118 7.47605 12.6561 7.45045L15.3364 5.9027C15.3806 5.87718 15.4293 5.86067 15.4799 5.85402C15.5304 5.84737 15.5818 5.85086 15.631 5.8641C15.6803 5.87733 15.7264 5.90014 15.7668 5.93124C15.8072 5.96235 15.8411 6.00102 15.8665 6.04524L17.2542 8.45063C17.3311 8.58544 17.4543 8.68774 17.601 8.73875C17.7476 8.78977 17.9077 8.78596 18.0518 8.72807C19.1674 8.29071 20.3279 7.97798 21.5122 7.79549C21.6646 7.77219 21.8036 7.69514 21.904 7.57818C22.0045 7.46122 22.0597 7.31207 22.0597 7.1579V4.38503C22.0604 4.28268 22.1015 4.18476 22.1741 4.11262C22.2467 4.04048 22.3449 4 22.4473 4H25.5427C25.6451 4 25.7433 4.04048 25.8159 4.11262C25.8885 4.18476 25.9296 4.28268 25.9302 4.38503V7.16049C25.9302 7.3143 25.985 7.46295 26.085 7.57986C26.1849 7.69676 26.3233 7.77424 26.4753 7.79808C27.6595 7.98075 28.8201 8.29348 29.9357 8.73067C30.0798 8.78802 30.2398 8.79156 30.3863 8.74059C30.5328 8.68962 30.6559 8.58749 30.7333 8.45307L32.1235 6.04783C32.1487 6.00372 32.1826 5.96505 32.2229 5.93414C32.2633 5.90323 32.3093 5.88064 32.3585 5.86776C32.4075 5.85443 32.4586 5.85112 32.5089 5.85799C32.5592 5.86486 32.6075 5.88176 32.6511 5.90774L35.3339 7.45548C35.3781 7.48087 35.4169 7.51473 35.448 7.55513C35.4792 7.59554 35.502 7.64171 35.5152 7.69095C35.5284 7.7402 35.5318 7.79148 35.5252 7.84204C35.5185 7.89259 35.502 7.94134 35.4764 7.98549L34.0863 10.3933C34.0092 10.5271 33.9825 10.684 34.0109 10.8357C34.0394 10.9875 34.1211 11.1241 34.2413 11.2209C35.1778 11.9711 36.0289 12.8222 36.7791 13.7588C36.8759 13.879 37.0127 13.9606 37.1646 13.9886C37.3164 14.0166 37.4733 13.9891 37.6067 13.9112L40.0145 12.5211C40.1021 12.4688 40.2068 12.4534 40.3057 12.4782C40.4046 12.5031 40.4896 12.5661 40.5421 12.6536L42.0873 15.3364C42.1134 15.3802 42.1305 15.4287 42.1377 15.4791C42.1448 15.5295 42.142 15.5809 42.1292 15.6302C42.1164 15.6795 42.0939 15.7257 42.0631 15.7663C42.0323 15.8069 41.9938 15.841 41.9497 15.8666L39.5445 17.2542C39.4099 17.3321 39.3077 17.4557 39.2567 17.6026C39.2058 17.7495 39.2094 17.9099 39.2669 18.0543C39.7044 19.1699 40.0172 20.3304 40.1995 21.5147C40.2234 21.6673 40.301 21.8064 40.4184 21.9068C40.5358 22.0072 40.6851 22.0623 40.8396 22.0623H43.6124C43.7152 22.0623 43.8138 22.1031 43.8865 22.1758C43.9592 22.2485 44 22.3471 44 22.4499V25.5452Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.2214 33.9962C25.6886 34.1261 28.1218 33.3755 30.0872 31.8784C28.837 27.4204 27.2817 27.5579 31.1072 23.7924C36.3879 13.1685 15.2029 9.60311 16.9431 21.2071C16.5831 22.5422 13.6926 24.1549 16.4004 24.755C16.5005 35.0613 21.316 24.125 23.3313 34.0062"
        stroke="#FF6633"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Media({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M9.7725 28.186C9.00884 28.9243 8.40728 29.8135 8.00612 30.797C7.60495 31.7805 7.41297 32.8367 7.44239 33.8985C7.47181 34.9603 7.722 36.0043 8.17701 36.964C8.63203 37.9238 9.28191 38.7783 10.0853 39.4732C10.7989 40.2444 11.6596 40.865 12.6168 41.2984C13.5739 41.7319 14.6081 41.9694 15.6584 41.9971C16.7087 42.0248 17.754 41.842 18.7326 41.4596C19.7113 41.0771 20.6035 40.5027 21.3567 39.7702L39.0548 22.0901"
        stroke="#FF6633"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.5528 13.5551L17.1054 27.0115C16.7462 27.3683 16.4609 27.7924 16.2656 28.2595C16.0703 28.7266 15.9689 29.2276 15.9672 29.7339C15.9655 30.2402 16.0636 30.7419 16.2558 31.2103C16.448 31.6787 16.7306 32.1046 17.0874 32.4638C17.4443 32.823 17.8683 33.1084 18.3354 33.3037C18.8026 33.499 19.3036 33.6004 19.8099 33.602C20.3162 33.6037 20.8178 33.5056 21.2862 33.3134C21.7546 33.1212 22.1806 32.8387 22.5398 32.4818L38.6785 16.3431C39.2781 15.8056 39.7577 15.1477 40.086 14.4124C40.4144 13.6771 40.5841 12.8808 40.5841 12.0755C40.5841 11.2703 40.4144 10.474 40.086 9.73869C39.7577 9.00338 39.2781 8.34551 38.6785 7.80797C38.1246 7.23601 37.4614 6.78122 36.7283 6.47063C35.9951 6.16005 35.2071 6 34.4109 6C33.6147 6 32.8266 6.16005 32.0935 6.47063C31.3604 6.78122 30.6972 7.23601 30.1433 7.80797L9.65039 28.3099"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Members({
  size,
  stroke = '#141A21',
  specialStroke = '#FF6633',
  ...props
}) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M36.93 20.2844C39.1469 20.2844 40.944 18.4873 40.944 16.2705C40.944 14.0537 39.1469 12.2566 36.93 12.2566C34.7132 12.2566 32.9161 14.0537 32.9161 16.2705C32.9161 18.4873 34.7132 20.2844 36.93 20.2844Z"
        stroke={stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.053 20.2844C13.2698 20.2844 15.0669 18.4873 15.0669 16.2705C15.0669 14.0537 13.2698 12.2566 11.053 12.2566C8.83615 12.2566 7.03906 14.0537 7.03906 16.2705C7.03906 18.4873 8.83615 20.2844 11.053 20.2844Z"
        stroke={stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9299 18.0278C26.1467 18.0278 27.9438 16.2307 27.9438 14.0139C27.9438 11.7971 26.1467 10 23.9299 10C21.7131 10 19.916 11.7971 19.916 14.0139C19.916 16.2307 21.7131 18.0278 23.9299 18.0278Z"
        stroke={specialStroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7006 27.1386C16.6801 27.1896 16.6678 27.2436 16.6641 27.2985L15.3325 36.2686H4L5.24288 27.8496C5.37314 26.9221 5.81096 26.0651 6.48597 25.4159C7.30798 24.5062 8.44396 23.9416 9.66542 23.8357H12.4364C13.664 23.9375 14.8068 24.5024 15.6332 25.4159C16.1224 25.8959 16.4886 26.4869 16.7006 27.1386Z"
        stroke={stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.0005 36.2683H32.5446L31.2305 27.3695C31.4273 26.628 31.8199 25.9532 32.3672 25.4156C33.1893 24.506 34.3252 23.9414 35.5467 23.8354H38.3177C39.5452 23.9373 40.6881 24.5022 41.5145 25.4156C42.183 26.0697 42.6196 26.9243 42.7576 27.8493L44.0005 36.2683Z"
        stroke={stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.776 37.814H15.1211L16.6666 27.3003C16.6702 27.2454 16.6825 27.1914 16.7031 27.1403C16.898 26.0448 17.4326 25.0383 18.2312 24.2633C19.2622 23.1156 20.692 22.4044 22.2293 22.2747H25.6748C27.2122 22.4044 28.642 23.1156 29.673 24.2633C30.5091 25.0799 31.0581 26.1454 31.2376 27.3003V27.3716L32.5517 36.2703L32.776 37.814Z"
        stroke={specialStroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function NotificationUnreadMessages({
  stroke = '#141A21',
  size,
  ...props
}) {
  return (
    <SvgIconComponent
      xmlns="http://www.w3.org/2000/svg"
      width="118"
      height="120"
      viewBox="0 0 118 120"
      fill="none"
      stroke={stroke}
      size={size}
      {...props}
    >
      <path
        d="M59.4346 28.085C59.5046 29.8277 59.7162 31.5336 60.0605 33.1914H5.10645V98.1084H37.4775L37.7715 98.126C38.4522 98.2049 39.0789 98.5539 39.502 99.1035L48.541 110.85L57.417 99.1201C57.8996 98.4825 58.6544 98.1084 59.4541 98.1084H91.915V58.0107C93.6578 57.9407 95.3636 57.73 97.0215 57.3857V100.661C97.0214 102.071 95.8778 103.215 94.4678 103.215H60.7256L50.5947 116.602C50.1144 117.236 49.3643 117.61 48.5684 117.613C47.7724 117.616 47.0216 117.247 46.5361 116.616L36.2236 103.215H2.55273C1.14291 103.215 8.9139e-05 102.071 0 100.661V30.6377C0.000247077 29.228 1.14301 28.0852 2.55273 28.085H59.4346ZM63.4961 78.2236C64.7838 78.3541 65.789 79.4416 65.7891 80.7637C65.7891 82.0858 64.7838 83.1742 63.4961 83.3047L63.2363 83.3174H15.748C14.338 83.3174 13.1943 82.1738 13.1943 80.7637C13.1944 79.3537 14.338 78.2109 15.748 78.2109H63.2363L63.4961 78.2236ZM79.0645 62.3818C80.4743 62.382 81.6171 63.5247 81.6172 64.9346C81.6172 66.3445 80.4744 67.4881 79.0645 67.4883H15.748C14.338 67.4883 13.1943 66.3447 13.1943 64.9346C13.1945 63.5246 14.338 62.3818 15.748 62.3818H79.0645ZM66.4385 46.5518C67.9923 48.454 69.767 50.1679 71.7217 51.6582H15.748C14.3381 51.6582 13.1946 50.5154 13.1943 49.1055C13.1943 47.6954 14.338 46.5518 15.748 46.5518H66.4385Z"
        fill={stroke}
      />
      <path
        className="special-color"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.6381 53.617C105.444 53.617 117.447 41.6144 117.447 26.8085C117.447 12.0026 105.444 0 90.6381 0C75.8322 0 63.8296 12.0026 63.8296 26.8085C63.8296 41.6144 75.8322 53.617 90.6381 53.617Z"
        fill="#FF9533"
      />
    </SvgIconComponent>
  )
}

export function Notification({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M11.168 15.2329H35.967"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.168 21.4329H35.967"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.168 27.6326H29.7673"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 8V35.4257H19.6788L24.0186 41.0654L28.2861 35.4257H42V8H6Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Pins({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M29.5952 18.394C30.1909 15.3006 28.1661 12.31 25.0727 11.7143C21.9793 11.1186 18.9887 13.1434 18.3931 16.2368C17.7974 19.3302 19.8221 22.3208 22.9155 22.9165C26.0089 23.5122 28.9995 21.4874 29.5952 18.394Z"
        stroke="#FF6633"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.2012 18.962C37.2783 18.4141 37.3164 17.8613 37.3152 17.308C37.3152 13.7785 35.9132 10.3936 33.4174 7.89782C30.9217 5.40209 27.5367 4 24.0072 4C20.4777 4 17.0928 5.40209 14.5971 7.89782C12.1013 10.3936 10.6992 13.7785 10.6992 17.308C10.6981 17.8613 10.7361 18.4141 10.8132 18.962C11.9532 30.14 24.0132 44 24.0132 44C24.0132 44 36.0612 30.14 37.2012 18.962Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Plans({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M29.998 21.3589H36.8542"
        stroke="#FF6633"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.114 29.5872C39.826 30.6865 39.1821 31.6595 38.2827 32.3541C37.3833 33.0487 36.2792 33.4258 35.1428 33.4265"
        stroke="#FF6633"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.1412 33.4289H11.1426V18.0005H36.8573"
        stroke="#FF6633"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.998 24.8564V33.4287"
        stroke="#FF6633"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.7148 26.5703V33.4265"
        stroke="#FF6633"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.8569 12.8562H6V38.5709H36.8569C38.2209 38.5709 39.5291 38.029 40.4936 37.0645C41.4581 36.1 41.999 34.7928 41.999 33.4288M36.8569 12.8562V28.2846C38.2209 28.2846 39.5291 28.8265 40.4936 29.791C41.4581 30.7555 41.999 32.0647 41.999 33.4288M36.8569 12.8562V6C38.2206 6 39.5285 6.54176 40.4929 7.5061C41.4572 8.47043 41.999 9.77835 41.999 11.1421V33.4288"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1426 26.5703H29.9991"
        stroke="#FF6633"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.8574 18.0005V26.5727"
        stroke="#FF6633"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.998 24.8567V18.0005"
        stroke="#FF6633"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Projects({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M43.2008 11.5717H4.80078V38.9997H43.2008V11.5717Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.3145 22.488H42.2865"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.71472 22.4523H16.6867"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6738 11.48V8.828C17.6738 8.58795 17.7211 8.35024 17.813 8.12846C17.9048 7.90667 18.0395 7.70516 18.2092 7.53541C18.379 7.36567 18.5805 7.23101 18.8023 7.13915C19.0241 7.04728 19.2618 7 19.5018 7H28.5018C28.7419 7 28.9796 7.04728 29.2014 7.13915C29.4232 7.23101 29.6247 7.36567 29.7944 7.53541C29.9642 7.70516 30.0988 7.90667 30.1907 8.12846C30.2825 8.35024 30.3298 8.58795 30.3298 8.828V11.48"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6597 18.7937H20.3457V26.1077H27.6597V18.7937Z"
        stroke="#FF6633"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Reports({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M31 8H39V44H17M17 44V36H9M17 44L9 36M9 36V8H17M21 6V4H27V6H31V10H17V6H21Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 26.0001H18L22 18.0001L26 36.0001L30 26.0001H32"
        stroke="#FF6633"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Tasks({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M14.6953 24.1721L21.0723 30.6724L33.5723 18.2773"
        stroke="#FF6633"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Templates({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M28.3039 22.4142H26.5383L23.0073 15.3521L19.4763 31.2418L15.9453 22.4142H14.1797"
        stroke="#141A21"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.4833 22.5947V8.73106H27.4211M27.4211 8.73106V6.9655H23.8901V5.20001H18.5935V6.9655H15.0625V10.4966H27.4211V8.73106Z"
        stroke="#141A21"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0625 40.5103H20.1384"
        stroke="#141A21"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.062 8.73138H8V33.4487"
        stroke="#141A21"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 33.4485L15.062 40.5106V33.4485H8Z"
        stroke="#141A21"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.8606 32.8413L37.5102 31.7224C37.4553 31.6963 37.412 31.6507 37.3888 31.5944L37.1902 31.1156C37.1683 31.0588 37.1683 30.9958 37.1902 30.939L38.062 28.4849C38.0777 28.4412 38.0805 28.3939 38.0704 28.3486C38.0602 28.3033 38.0374 28.2618 38.0046 28.2289L36.8371 27.0615C36.8042 27.0286 36.7628 27.0058 36.7175 26.9956C36.6721 26.9855 36.6248 26.9884 36.5811 27.0041L34.127 27.8758C34.0702 27.8977 34.0073 27.8977 33.9505 27.8758L33.4716 27.6772C33.4153 27.654 33.3697 27.6108 33.3436 27.5558L32.2247 25.2055C32.2047 25.1639 32.1735 25.1287 32.1344 25.1041C32.0954 25.0795 32.0502 25.0665 32.004 25.0665H30.351C30.3049 25.0665 30.2597 25.0795 30.2206 25.1041C30.1816 25.1287 30.1503 25.1639 30.1304 25.2055L29.0115 27.5558C28.9853 27.6108 28.9397 27.654 28.8835 27.6772L28.4046 27.8758C28.3478 27.8977 28.2848 27.8977 28.228 27.8758L25.7739 27.0041C25.7302 26.9884 25.6829 26.9855 25.6376 26.9956C25.5923 27.0058 25.5508 27.0286 25.5179 27.0615L24.3505 28.2289C24.3176 28.2618 24.2948 28.3033 24.2846 28.3486C24.2745 28.3939 24.2774 28.4412 24.2931 28.4849L25.1649 30.939C25.1868 30.9958 25.1868 31.0588 25.1649 31.1156L24.9662 31.5944C24.943 31.6507 24.8998 31.6963 24.8448 31.7224L22.4945 32.8413C22.4529 32.8613 22.4178 32.8926 22.3932 32.9316C22.3686 32.9707 22.3555 33.0159 22.3555 33.062V34.715C22.3555 34.7611 22.3686 34.8063 22.3932 34.8454C22.4178 34.8844 22.4529 34.9157 22.4945 34.9357L24.8448 36.0545C24.8999 36.0805 24.9432 36.1262 24.9662 36.1826L25.1649 36.6615C25.1868 36.7183 25.1868 36.7812 25.1649 36.838L24.2931 39.2921C24.2774 39.3358 24.2745 39.3831 24.2846 39.4284C24.2948 39.4737 24.3176 39.5152 24.3505 39.5481L25.5179 40.7155C25.5508 40.7484 25.5923 40.7712 25.6376 40.7814C25.6829 40.7915 25.7302 40.7886 25.7739 40.7729L28.228 39.9012C28.2848 39.8792 28.3478 39.8792 28.4046 39.9012L28.8835 40.0998C28.9397 40.123 28.9853 40.1662 29.0115 40.2212L30.1304 42.5715C30.1503 42.6131 30.1816 42.6483 30.2206 42.6729C30.2597 42.6975 30.3049 42.7106 30.351 42.7106H32.004C32.0502 42.7106 32.0954 42.6975 32.1344 42.6729C32.1735 42.6483 32.2047 42.6131 32.2247 42.5715L33.3436 40.2212C33.3697 40.1662 33.4153 40.123 33.4716 40.0998L33.9505 39.9012C34.0073 39.8792 34.0702 39.8792 34.127 39.9012L36.5811 40.7729C36.6248 40.7886 36.6721 40.7915 36.7175 40.7814C36.7628 40.7712 36.8042 40.7484 36.8371 40.7155L38.0046 39.5481C38.0374 39.5152 38.0602 39.4737 38.0704 39.4284C38.0805 39.3831 38.0777 39.3358 38.062 39.2921L37.1902 36.838C37.1683 36.7812 37.1683 36.7183 37.1902 36.6615L37.3888 36.1826C37.4118 36.1262 37.4552 36.0805 37.5102 36.0545L39.8606 34.9357C39.9022 34.9157 39.9373 34.8844 39.9619 34.8454C39.9865 34.8063 39.9996 34.7611 39.9996 34.715V33.062C39.9996 33.0159 39.9865 32.9707 39.9619 32.9316C39.9373 32.8926 39.9022 32.8613 39.8606 32.8413ZM31.172 36.8314C30.5902 36.8314 30.0214 36.6588 29.5376 36.3356C29.0539 36.0123 28.6768 35.553 28.4541 35.0154C28.2315 34.4779 28.1733 33.8864 28.2868 33.3157C28.4003 32.7451 28.6804 32.2209 29.0919 31.8095C29.5033 31.398 30.0275 31.1179 30.5981 31.0044C31.1688 30.8909 31.7603 30.9491 32.2978 31.1717C32.8354 31.3944 33.2947 31.7715 33.618 32.2552C33.9412 32.739 34.1138 33.3078 34.1138 33.8896C34.1138 34.6698 33.8038 35.4181 33.2522 35.9698C32.7005 36.5214 31.9522 36.8314 31.172 36.8314Z"
        stroke="#FF6633"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function PlanSimple({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="26"
      width="33"
      fill="none"
      viewBox="0 0 33 26"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M31.3335 15.0272V5.27434C31.3305 4.14234 30.7813 3.04526 29.9807 2.24482C29.1802 1.44437 28.0952 1.00298 26.963 1V16.4556C27.5322 16.4425 28.0982 16.5433 28.6279 16.752C29.1575 16.9608 29.6401 17.2732 30.0473 17.6711C30.4544 18.0689 30.778 18.5441 30.9988 19.0688C31.2197 19.5934 31.3335 20.1569 31.3335 20.7261C31.3335 21.2953 31.2197 21.8588 30.9988 22.3834C30.778 22.9081 30.4544 23.3833 30.0473 23.7811C29.6401 24.179 29.1575 24.4914 28.6279 24.7002C28.0982 24.9089 27.5322 25.012 26.963 24.9989H1.3335V5.00376H22.7738"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.48148"
      />
    </SvgIconComponent>
  )
}

export const Help = ({ size, ...props }) => (
  <SvgIconComponent
    height="24"
    width="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    size={size}
    {...props}
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.59375 9.25507C8.83943 8.48575 9.35892 7.83332 10.0537 7.42167C10.601 7.10069 11.226 6.93641 11.8604 6.94672C12.7121 6.92752 13.5429 7.21095 14.2053 7.74668C14.7361 8.22663 15.0734 8.88386 15.1538 9.59493C15.2342 10.306 15.0521 11.022 14.6419 11.6084C14.2812 12.1134 13.8062 12.5257 13.2554 12.8117C12.7578 13.0605 12.3108 13.3996 11.9371 13.8117C11.564 14.2488 11.3605 14.8054 11.3637 15.38C11.3637 15.4134 11.3637 15.4467 11.3637 15.48C11.3637 15.5134 11.3637 15.5767 11.3637 15.6184"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3877 17.7388C11.421 17.7456 11.4521 17.762 11.4766 17.7866C11.5008 17.8111 11.5177 17.8427 11.5244 17.8765C11.531 17.9101 11.5277 17.9453 11.5146 17.9771C11.5015 18.0089 11.4786 18.036 11.4502 18.0552C11.4224 18.0738 11.3898 18.0837 11.3564 18.0845C11.3095 18.0833 11.264 18.0645 11.2305 18.0308C11.197 17.9969 11.1783 17.9513 11.1777 17.9038C11.1789 17.8706 11.1893 17.8384 11.208 17.811C11.2276 17.7825 11.2554 17.7604 11.2871 17.7476C11.319 17.7347 11.354 17.7319 11.3877 17.7388Z"
      fill="white"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIconComponent>
)

export const HelpAvailable = ({ size, ...props }) => (
  <SvgIconComponent
    height="48"
    width="48"
    fill="none"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    size={size}
  >
    <path
      d="M17.1875 18.5101C17.6789 16.9715 18.7178 15.6666 20.1074 14.8433C21.202 14.2014 22.4519 13.8728 23.7207 13.8934C25.4241 13.855 27.0859 14.4219 28.4106 15.4934C29.4722 16.4533 30.1468 17.7677 30.3076 19.1899C30.4684 20.612 30.1043 22.044 29.2839 23.2168C28.5625 24.2268 27.6124 25.0515 26.5108 25.6234C25.5156 26.1209 24.6215 26.7992 23.8741 27.6235C23.128 28.4976 22.721 29.6108 22.7275 30.7601C22.7275 30.8268 22.7275 30.8934 22.7275 30.9601C22.7275 31.0267 22.7275 31.1534 22.7275 31.2368"
      stroke="#141A21"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M22.4619 36.0613C22.3949 35.9938 22.3569 35.9033 22.3555 35.8086C22.3577 35.7417 22.3789 35.677 22.4166 35.622C22.4558 35.5649 22.5108 35.5208 22.5743 35.4952C22.6382 35.4694 22.7085 35.463 22.776 35.4769C22.8427 35.4906 22.9046 35.524 22.9537 35.5734C23.0023 35.6223 23.0353 35.6844 23.0487 35.752C23.062 35.8195 23.0552 35.8894 23.0289 35.9532C23.0026 36.0172 22.9582 36.0715 22.9013 36.11C22.8459 36.1474 22.7807 36.1682 22.714 36.1698C22.6196 36.1678 22.5292 36.1291 22.4619 36.0613Z"
      fill="#141A21"
      stroke="#141A21"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M40 16C44.4183 16 48 12.4183 48 8C48 3.58172 44.4183 0 40 0C35.5817 0 32 3.58172 32 8C32 12.4183 35.5817 16 40 16Z"
      fill="#4D8CE8"
      fillRule="evenodd"
    />
    <path
      d="M31.7209 4.46481C31.4602 5.07444 31.2649 5.71868 31.1438 6.38873C28.9384 5.49326 26.5268 5 24 5C13.5066 5 5 13.5066 5 24C5 34.4934 13.5066 43 24 43C34.4934 43 43 34.4934 43 24C43 21.4732 42.5067 19.0616 41.6113 16.8562C42.2813 16.7351 42.9256 16.5398 43.5352 16.2791C44.4805 18.669 45 21.2739 45 24C45 35.598 35.598 45 24 45C12.402 45 3 35.598 3 24C3 12.402 12.402 3 24 3C26.7261 3 29.331 3.51946 31.7209 4.46481Z"
      fill="#141A21"
      fillRule="evenodd"
    />
    <circle cx="38" cy="10" fill="#4D8CE8" r="4" />
  </SvgIconComponent>
)

export const Search = ({ size, ...props }) => (
  <SvgIconComponent
    height="48"
    width="48"
    fill="none"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    size={size}
  >
    <path
      d="M20.0342 34.0684C27.7851 34.0684 34.0684 27.7851 34.0684 20.0342C34.0684 12.2833 27.7851 6 20.0342 6C12.2833 6 6 12.2833 6 20.0342C6 27.7851 12.2833 34.0684 20.0342 34.0684Z"
      fillRule="evenodd"
      stroke="#141A21"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M42 42.0014L30.5586 30.5601L42 42.0014Z"
      fillRule="evenodd"
      stroke="#141A21"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </SvgIconComponent>
)

const iconPropTypes = {
  size: PropTypes.oneOf(Object.keys(iconSizes))
}

Datasets.propTypes = iconPropTypes
Groups.propTypes = iconPropTypes
Licenses.propTypes = iconPropTypes
Maestro.propTypes = iconPropTypes
Media.propTypes = iconPropTypes
Members.propTypes = iconPropTypes
NotificationUnreadMessages.propTypes = iconPropTypes
Notification.propTypes = iconPropTypes
Pins.propTypes = iconPropTypes
Plans.propTypes = iconPropTypes
Projects.propTypes = iconPropTypes
Reports.propTypes = iconPropTypes
Tasks.propTypes = iconPropTypes
Templates.propTypes = iconPropTypes
PlanSimple.propTypes = iconPropTypes
Help.protoTypes = iconPropTypes
HelpAvailable.protoTypes = iconPropTypes
Search.protoTypes = iconPropTypes

const iconsMenu = {
  Datasets,
  Groups,
  Licenses,
  Maestro,
  Media,
  Members,
  NotificationUnreadMessages,
  Notification,
  Pins,
  Plans,
  Projects,
  Reports,
  Tasks,
  Templates,
  PlanSimple,
  Help,
  HelpAvailable,
  Search
}

export default iconsMenu
